import Component from "./NewOrders";
export default Component;
